/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * DTO for an Answer value
 */
export interface AnswerValue {

  /**
   * Label
   */
  label?: string | null;

  /**
   * Type
   */
  type?: string | null;

  /**
   * Value
   */
  value?: string | null;
}

export class AnswerValue {
  label?: string | null;
  type?: string | null;
  value?: string | null;

  constructor(value: AnswerValue) {
    this.label = value?.label;
    this.type = value?.type;
    this.value = value?.value;
  }
}
